import React from "react";

// CSS
import "../../css/black-link.css";

class BlackDiv extends React.PureComponent {
	render() {
		return <div className="black-link">{this.props.children}</div>;
	}
}

export default BlackDiv;



// WEBPACK FOOTER //
// ./src/components/utils/BlackDiv.js